export default __webpack_public_path__ + "static/media/genericFlag.a640b329.svg";